import * as React from "react";
import {
  Provider as PaperProvider,
  Text,
  TextInput,
  DefaultTheme,
  Divider,
} from "react-native-paper";
import {
  whiteColor,
  blackColor,
  greyColor,
  redBorderInputColor,
  redBackgroundColor,
} from "../../common/colors";
import { Image, StyleSheet, View, ScrollView, Dimensions } from "react-native";
import { connect } from "react-redux";
import { actionCreators } from "./action";
import Button from "../../common/Button";
import checker from "../../common/helpers/checker";
import routes from "../../routing/routes";
import Link from "../../common/Link";
import Error from "../../common/Error";

import logoApple from "../Images/LogoApple.png";
import logoFacebook from "../Images/LogoFacebook.png";
import logoGoogle from "../Images/LogoGoogle.png";
import PageContainer from "../../common/PageContainer";
import MAX_WIDTH from '../../common/MaxWidth';
import t from '../../translations';

const inputPadding = 12;

const ForgotPassword = (props) => {
  const [email, setEmail] = React.useState("");

  React.useEffect(() => {
    if (props.error) {
      props.saveErrorReponse(null);
    }
    return () => {
      props.saveErrorReponse(null);
    };
  }, []);

  const theme = {
    ...DefaultTheme,
    roundness: 0,
    colors: {
      ...DefaultTheme.colors,
      primary: blackColor,
    },
  };

  const onClickLink = () => props.navigation.navigate(routes.RegistrationForm);

  const goToSendMessageReset = () => {
    props.navigation.navigate(routes.SendMessageReset);
  };
  const onSend = () => {
    props.resetPassword({ email, redirect: goToSendMessageReset });
  };

  const win = Dimensions.get("window");

  return (
    <PageContainer
      {...props}
      noBackground={true}
      isBackIcon={true}
      backRoute={routes.SignIn}
      maxWidth={MAX_WIDTH.AUTHENTICATION}
    >
      <View style={styles.container}>
        <Text style={styles.title}>{t('forgotPassword_title')}</Text>
      </View>
      <View style={styles.forgotcontainer}>
        <Text style={styles.forgotmessage}>
         {t('forgotPassword_forgotmessage')}
        </Text>
        <Text style={styles.forgotmessagetwo}>{t('forgotPassword_forgotmessagetwo')}</Text>
      </View>
      <View style={styles.inputsContainer}>
        <TextInput
          label={t('forgotPassword_email')}
          value={email}
          onChangeText={(text) => {
            setEmail(text);
            props.error && props.saveErrorReponse(null);
          }}
          mode="outlined"
          returnKeyType="go"
          onSubmitEditing={onSend}
          error={props.error && { ...styles.inputBorderError, width: '100%' }}
          style={props.error ?
            {
              ...styles.inputError, width: '100%'
            }
            :
            {
              ...styles.input, width: '100%'
            }}
        />
        <Error error={props.error} />
        <View style={styles.buttonContainer}>
          <Button onPress={onSend} value={t('forgotPassword_send')} />
        </View>
        {/* <View style={styles.linecontainer}>
            <Divider style={styles.breakline}>
            <Text style={styles.or}>Lub</Text>
            </Divider>
        </View> 
        <View style={styles.continue}>
            <Text style={styles.continuewithaccounts}>Kontynnuj za pomocą:</Text>
        </View>
        <View style={styles.logoicons}>
                <View style={styles.emptyspace}>
                    <Image source={logoApple} style={styles.logo}/>
                </View>
                <View style={styles.emptyspace}>
                    <Image source={logoFacebook} style={styles.logo}/>
                </View>
                <Image source={logoGoogle} style={styles.logo}/>
            </View> */}
        <View style={styles.footerContainer}>
          <Text style={styles.askbox}>{t('forgotPassword_askbox')}</Text>
          <Link onPress={onClickLink}> {t('forgotPassword_create_profile')}</Link>
        </View>
      </View>
    </PageContainer>
  )
};
const mapStateToProps = (state) => {
  const errorMessage = state.errorMessages && checker(state.errorMessages.code);

  return { error: errorMessage };
};
export default connect(mapStateToProps, actionCreators)(ForgotPassword);

const styles = StyleSheet.create({
  inputsContainer: {
    backgroundColor: whiteColor,
    alignItems: "flex-start",
    display: "flex",
    width: '100%',
  },
  wrapper: {
    alignItems: "center",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 30,
    backgroundColor: whiteColor,
  },
  input: {
    paddingTop: 36,
    paddingBottom: 30,
    backgroundColor: whiteColor,
    height: 42,
  },
  inputBorderError: {
    borderColor: redBorderInputColor,
    borderWidth: 1,
    borderStyle: "solid",
  },
  inputError: {
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: redBackgroundColor,
    height: 42,
  },
  divider: {
    height: 10,
    backgroundColor: whiteColor,
  },
  buttonContainer: {
    alignItems: "center",
    display: "flex",
    paddingTop: 10,
    paddingLeft: 24,
    paddingRight: 24,
  },
  container: {
    backgroundColor: whiteColor,
    alignItems: 'flex-start',
  },
  title: {
    textAlign: "center",
    fontSize: 26,
    paddingRight: 30,
    letterSpacing: 1.25,
    textTransform: "uppercase",
  },
  forgotcontainer: {
    backgroundColor: whiteColor,
  },
  forgotmessage: {
    fontSize: 16,
    lineHeight: 21,
    letterSpacing: 1.25,
  },
  forgotmessagetwo: {
    fontSize: 16,
    lineHeight: 21,
    letterSpacing: 1.25,
  },
  linecontainer: {
    backgroundColor: whiteColor,
    width: 260,
    paddingTop: 50,
    paddingBottom: 20,
  },
  breakline: {
    height: 1,
    backgroundColor: greyColor,
  },
  or: {
    textAlign: "center",
    alignSelf: "center",
    width: 45,
    marginTop: -6,
    height: 10,
    color: greyColor,
    fontSize: 10,
    letterSpacing: 1.25,
    backgroundColor: whiteColor,
  },
  continue: {
    paddingTop: 2,
  },
  continuewithaccounts: {
    color: blackColor,
    fontSize: 12,
    letterSpacing: 1.25,
  },
  logoicons: {
    paddingTop: 12,
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
  },
  logo: {
    width: 56,
    height: 56,
    alignItems: "center",
  },
  emptyspace: {
    paddingRight: 26,
  },
  footerContainer: {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    paddingTop: 20,
    paddingBottom: 40,
  },
  askbox: {
    fontSize: 12,
    letterSpacing: 1.25,
    color: greyColor,
  },
});
